import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import EnterpriseSolutionHero from "./EnterpriseSolutionHero";
import YEBNeeds from "./YEBNeeds";
import IndustrySpecific from "./IndustrySpecific";

function EnterpriseSolution() {
  return (
    <div>
      <Header />
      <EnterpriseSolutionHero />
      <YEBNeeds />
      <IndustrySpecific />
      <Footer />
    </div>
  );
}

export default EnterpriseSolution;
